import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { Link, useLocation } from "react-router-dom";
// material ui
import { Stack, Box, IconButton } from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
import PreviewIcon from '@mui/icons-material/Preview';
// components

import Layout from "../../../../layout/Layout";
import { assessmentTypes } from "../../../../components/common/staticTemplate";
import { HeaderDropDown } from "../../../../components/common/HeaderDropdown";
import { MuiDataGrid, GridCellExpand, Notifier, ErrorNotifier, MuiTooltip, CommonCurdPopUp } from "../../../../components";
import ConfirmDialog from "../../../../components/common/ConfirmDialog";
// redux


import {
  getassessmentEmailType,
  getassessmentType,
  deleteassessmentType,
  resetErrMessage,
  resetMessage,
  rowSelect,
} from "../../../../features/config/assessmentTypeSlice";
import { Margin } from "@mui/icons-material";

// ----------------------------------------------------------------------------------

const AssessmentType = () => {

  const [showAdd, setShowAdd] = useState(false);
  const [standardTemplate, setStandardTemplate] = useState("")
  const [showEdit, setShowEdit] = useState(false);
  const [previewEmail, setPreviewEmail] = useState(false);
  const [assessmentCategory, setAssessmentCategory] = useState(null)
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const location = useLocation()
  const htmlRef = useRef(null);
  const dispatch = useDispatch();
  const { assessmentTypeData, assessmentEmailData, selectedData, message, errMessage } =
    useSelector((state) => ({ ...state.assessmentTypeConfig }));

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }



  const data = {
    rows: assessmentEmailData?.length > 0
      ? assessmentCategory ?  assessmentEmailData?.filter((data)=>data.emailCategory === assessmentCategory?.name ) :  assessmentEmailData
      : [],
    columns: [
      { field: "templateName", headerName: "Template Name", width: 250 },
      { field: "variableName", headerName: "Template Type", width: 250 },
      { field: "emailCategory", headerName: "Template Category", width: 200, renderCell: renderCellExpand },
      { field: "status", headerName: "Status", width: 150, renderCell: renderCellExpand },
      {
        field: "preview",

        // headerName: 'Actions',
        type: "actions",
        width: 50,
        renderCell: (params) => {
          console.log(params?.row)
          return (
            <MuiTooltip title="Preview  Template" placement="right">

              <IconButton onClick={() => {
                setPreviewEmail(true)
                dispatch(rowSelect([params?.row]))
              }} sx={{ p: 0 }}>
                <PreviewIcon color="primary" />
              </IconButton>

            </MuiTooltip>
          );
        },
      },
       

    ],
  };

  const showAddPage = () => {
    setShowAdd(!showAdd);
  };

  const showEditPage = () => {
    setShowEdit(true);
  };

  const showDelete = () =>
    setConfirmDialog({
      isOpen: true,
      title: "Are you sure to delete this record?",
      subTitle: "You can't undo this operation",
      onConfirm: () => handleDelete(),
    })

  useEffect(() => {
    dispatch(getassessmentEmailType());
  }, []);

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const handleDelete = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deleteassessmentType(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(getassessmentType());
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  console.log(selectedData)

  return (
    <Layout>

      <>
        {/* <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          width="100%"
        
        >
          <Link
            to="/exco/platform/config"
            state={{ l3Menu: location?.state?.l3Menu }}
          >
            <CancelIcon color="red" />
          </Link>
          
        </Stack> */}



<Box
  sx={{
    display: "flex",
    alignItems: "center",
    width: "100%",
  }}
>
  {/* Header - 98% */}
  <Box sx={{ width: "98%" }}>
    <HeaderDropDown
      sx={{ margin: 0 }}
      name="Template category"
      heading="Default Email Templates"
      assessmentTypeData={assessmentTypes}
      assessmentType={assessmentCategory}
      setAssessmentType={(value) =>
        setAssessmentCategory(value)
      }
    />
  </Box>

  {/* Cancel Icon - 2% */}
  <Box
    sx={{
      width: "2%",
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    }}
  >
     <Link  aria-label="cancel" to="/exco/platform/config" state={{l3Menu: location?.state?.l3Menu}}>
              <CancelIcon color="red" />
         </Link>
  </Box>
</Box>
       

        <MuiDataGrid
          setShowAdd={
            false}
          setShowEdit={
            // location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "update") && 
            false}
          setShowDelete={
            // location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "delete") && 
            false
          }

          toolbarColumn={true}
          // toolbarFilter = {true}
          toolbarDensity={true}
          toolbarExport={true}
          data={data}
          select={(data) => dispatch(rowSelect(data))}
        />
      </>

      {previewEmail && <CommonCurdPopUp

        mediumScreen={true}
        close={
          () => setPreviewEmail(false)
        }
      >

      <div ref={htmlRef} >
          <h5 className="center bold pt-2 header-font-size">Email Preview</h5>
          <div  dangerouslySetInnerHTML={{
      __html: `
        <div style=padding-left:9.5rem;border-bottom:1px solid #ddd; font-size:30px">
          <strong>Subject: </strong> ${selectedData?.subject || ""}
        </div>
        ${selectedData?.preview || ""}
      `,
    }} />
        </div>

        

















      </CommonCurdPopUp>}


      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}
    </Layout>
  );
};

export default AssessmentType;
